import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import { Button, Form, Spinner } from 'react-bootstrap'
import PasswordInput from 'components/forms/passwordInput'

import { PasswordResetInfo } from '../types'
import authLinksCss from 'components/layout/auth/authLinks.module.scss'

type NewPasswordFormProps = {
  values: PasswordResetInfo
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: (event: React.ChangeEvent<HTMLFormElement>) => void
  validated: boolean
  submitting: boolean
  disabled?: boolean
  submitLabel: string
  passwordLabel: string
  confirmationLabel: string
}

/** Password + confirmation form shared by "create" and "reset" password. */
const NewPasswordForm: FunctionComponent<NewPasswordFormProps> = ({
  values,
  onChange,
  onSubmit,
  validated,
  submitting,
  disabled,
  submitLabel,
  passwordLabel,
  confirmationLabel,
}) => (
  <Form noValidate validated={validated} onSubmit={onSubmit}>
    <Form.Group className="mb-3" controlId="new-password">
      <Form.Label>{passwordLabel}</Form.Label>
      <PasswordInput
        name="password"
        autoComplete="new-password"
        value={values.password}
        onChange={onChange}
        required
      >
        <Form.Control.Feedback type="invalid">Informe uma senha.</Form.Control.Feedback>
      </PasswordInput>
    </Form.Group>

    <Form.Group controlId="new-password-confirmation">
      <Form.Label>{confirmationLabel}</Form.Label>
      <PasswordInput
        name="passwordConfirmation"
        autoComplete="new-password"
        value={values.passwordConfirmation}
        onChange={onChange}
        required
      >
        <Form.Control.Feedback type="invalid">Confirme a senha.</Form.Control.Feedback>
      </PasswordInput>
    </Form.Group>

    <Button
      type="submit"
      size="lg"
      className="w-100 mt-4"
      disabled={disabled || submitting}
    >
      {submitting && <Spinner size="sm" animation="border" />}
      {submitting ? 'Processando…' : submitLabel}
    </Button>

    <p className={`${authLinksCss.links} ${authLinksCss.center}`}>
      <Link to="/login">← Voltar para o login</Link>
    </p>
  </Form>
)

export default NewPasswordForm
